module.exports = "/_next/static/images/truck-2-2533f425509af28a6493b808648fa64b.png.webp";